<div class="filter-row">
  <hau-form [formGroup]="filterForm">
    <div class="filter-group">
      <div class="filter-control-group">
        <hau-form-field label="Interner Tenant">
          @if (context()?.internalTenantSelectable) {
            <nb-select fullWidth formControlName="internalTenantId" placeholder="Kein Bericht vorhanden"
                       data-cy="defect-report-internal-tenant">
              @for (tenant of context()?.internalTenants ?? []; track tenant.id) {
                <nb-option [value]="tenant.id">{{ tenant.name }}</nb-option>
              }
            </nb-select>
          } @else {
            <input nbInput fullWidth data-cy="defect-report-internal-tenant-name"
                   [value]="selectedInternalTenantName() ?? '–'" [disabled]="true" />
          }
        </hau-form-field>
      </div>
      @if (!isExternal) {
        <div class="filter-control-group">
          <hau-form-field label="Kunde">
            <wr-tenant-select [tenantType]="'External'" formControlName="externalTenantId"></wr-tenant-select>
          </hau-form-field>
        </div>
      }
      @if (selectedInternalTenantId(); as internalTenantId) {
        <div class="filter-control-group">
          <hau-form-field label="Prüfpunkt">
            <wr-checkpoint-select [tenantId]="internalTenantId" formControlName="checkpointId"></wr-checkpoint-select>
          </hau-form-field>
        </div>
      }
      <div class="filter-control-group">
        <hau-form-field label="Gebäude">
          <wr-building-multi-select
            [tenantId]="filterForm.controls.externalTenantId.value"
            (selectionChange)="onBuildingsChange($event)">
          </wr-building-multi-select>
        </hau-form-field>
      </div>
      @if (selectedInternalTenantId(); as internalTenantId) {
        <div class="filter-control-group">
          <hau-form-field label="Maßnahme">
            <wr-action-select
              [tenantId]="internalTenantId"
              [additionalActions]="availableActions()"
              formControlName="action"
              [showAllOption]="true">
            </wr-action-select>
          </hau-form-field>
        </div>
      }
      @if (isExternal) {
        <div class="filter-control-group">
          <hau-form-field label="Team">
            <wr-team-select [fixedTenantId]="currentTenant()?.id" formControlName="team"></wr-team-select>
          </hau-form-field>
        </div>
      }
      <div class="filter-control-group">
        <hau-form-field label="Reparaturauftrag">
          <nb-select fullWidth multiple placeholder="Alle" formControlName="repairTask" data-cy="defect-report-repair-task-filter">
            @for (option of repairTaskOptions; track option) {
              <nb-option [value]="option">
                @if (option === withoutRepairTask) {
                  Kein Reparaturauftrag
                } @else {
                  {{ option | repairTaskStatusTranslation }}
                }
              </nb-option>
            }
          </nb-select>
        </hau-form-field>
      </div>
    </div>
  </hau-form>
</div>

<div class="results" [nbSpinner]="loading()">
  <div class="sort-header">
    @for (column of sortableColumns; track column.key) {
      <div class="sort-header-cell" role="button" tabindex="0"
           (click)="toggleSort(column.key)" (keydown.enter)="toggleSort(column.key)">
        <span>{{ column.label }}</span>
        @if (sort()?.sort === column.key) {
          <nb-icon pack="eva" [icon]="sort()?.order === 'ASC' ? 'arrow-ios-downward' : 'arrow-ios-upward'"></nb-icon>
        }
      </div>
    }
    <div class="sort-header-cell static">Reparaturauftrag</div>
    <div class="sort-header-cell static">TGA</div>
  </div>
  @if (entries().length) {
    <wr-list-view
      [items]="entries()"
      [showSearch]="false"
      [canCreate]="false"
      (selectedChange)="openEntry($event)"
      (scrolledToEnd)="loadMore()">
      <ng-template wrListItem let-entry>
        <div class="entry-row" data-cy="defect-report-row">
          <span class="entry-address">{{ entry.sectionText }}</span>
          <span class="entry-date">{{ entry.inspectionSendingTimestamp ? (entry.inspectionSendingTimestamp | date: 'dd.MM.yyyy') : '–' }}</span>
          <span class="entry-deadline">{{ entry.deadline ? (entry.deadline | deadlineTranslation) : '–' }}</span>
          <span class="entry-action">{{ entry.action?.name ?? '–' }}</span>
          <span class="entry-repair-task" data-cy="defect-report-repair-task-status">
            @if (entry.repairTaskStatus) {
              <wr-repair-task-status-text [status]="entry.repairTaskStatus"></wr-repair-task-status-text>
            } @else {
              Kein Auftrag
            }
          </span>
          <span class="tga-count">{{ entry.buildingEquipmentCount }} TGA</span>
        </div>
      </ng-template>
    </wr-list-view>
    @if (loadingMore()) {
      <div class="loading-more">
        <nb-icon pack="fas" icon="spinner"></nb-icon>
        <span>Weitere Einträge werden geladen…</span>
      </div>
    }
  } @else if (!loading() && initialized()) {
    <div class="empty-hint" data-cy="defect-report-empty">
      <nb-icon pack="eva" icon="slash-outline"></nb-icon>
      <span>Keine Mängel oder Schäden für die gewählten Filter im letzten Bericht.</span>
    </div>
  }
</div>
